import styled, { css } from "styled-components"
import Tooltip from "components/atoms/Tooltip"

const linkStyles = css`
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 2rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  margin-right: 1.2rem;
  cursor: pointer;

  ${({ theme }) => theme.mq.large} {
    margin-right: 2.4rem;
  }

  &:last-child {
    margin-right: 0;
  }
`

const StyledIcon = styled.div`
  width: auto;
  height: 1.6rem;
  display: inline-block;
  margin-right: 0.4rem;

  & svg {
    width: auto;
    height: 100%;
    fill: ${({ theme }) => theme.color.secondary02};
  }
`

const backButtonStyles = css`
  ${linkStyles};
  padding-bottom: 0.8rem;
  color: ${({ theme }) => theme.color.secondary01};
  width: max-content;

  &:hover,
  &:active {
    text-decoration: underline;
    & svg {
      fill: ${({ theme }) => theme.color.secondary01};
    }
  }
  &:active {
    color: ${({ theme }) => theme.color.secondary01};
  }

  ${({ theme }) => theme.mq.medium} {
    padding-bottom: 0.6rem 0 0.2rem;
  }
`

const linkButtonStyles = css`
  ${linkStyles}
  color: ${({ theme }) => theme.color.secondary01};

  &:hover,
  &:active {
    text-decoration: underline;
    color: ${({ theme }) => theme.color.main03};

    svg {
      fill: ${({ theme }) => theme.color.main03};
    }
  }
  &:active {
    color: ${({ theme }) => theme.color.main02};

    svg {
      fill: ${({ theme }) => theme.color.main02};
    }
  }
`

const subscribeButtonStyles = css`
  ${linkButtonStyles}
  border: none;
  padding: 0;
  background-color: transparent;
  min-height: auto;

  :hover {
    background-color: transparent;
  }
`

// Preserves the original h4 visual size (font-family/weight/size/line-height
// as rendered by GlobalStyles' h4 tag selector + mixins.h4Sizes) now that
// this heading is semantically an h1 (each project-detail page's only page
// heading). h4Sizes is identical at both breakpoints, so no override is
// needed inside the medium media query below.
const headingStyles = css`
  font-family: ${({ theme }) => theme.font.family.headers};
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.4rem;
  padding: 0.8rem 0;

  ${({ theme }) => theme.mq.medium} {
    padding: 0.6rem 0;
  }
`
const StyledNavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.4rem 0 0;
  max-width: ${({ theme }) => theme.gridWidth};
  width: 100%;
  margin: 7.2rem auto 0;

  ${({ theme }) => theme.mq.medium} {
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem ${({ theme }) => theme.layout.mobilePadding};
  }
`

const StyledContainer = styled.div`
  padding: 2.4rem ${({ theme }) => theme.layout.mobilePadding} 0;

  ${({ theme }) => theme.mq.medium} {
    padding: 0;
  }
`

const StyledButtonWrapper = styled.div`
  display: flex;
  padding-top: 0.8rem;

  ${({ theme }) => theme.mq.medium} {
    padding-top: 1.6rem;
  }
`
const StyledLocationIconRect = styled.div`
  width: 0.4rem;
  height: 0.4rem;
  background: ${({ theme }) => theme.color.white};
  transform: rotate(45deg);
`

const StyledLocationIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.secondary02};
  flex-shrink: 0;
  margin-right: 0.4rem;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${({ theme }) => theme.color.main03};
    `}
`
const addressLinkStyles = css`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.secondary01};
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.25px;
  cursor: pointer;

  &:hover {
    ${StyledLocationIcon} {
      background: ${({ theme }) => theme.color.main03};
    }
  }

  &:visited {
    color: ${({ theme }) => theme.color.secondary01};
  }
`

const StyledTooltip = styled(Tooltip)`
  border: 1px solid ${({ theme }) => theme.color.main03} !important;
`
export {
  backButtonStyles,
  linkButtonStyles,
  headingStyles,
  StyledNavWrapper,
  StyledContainer,
  StyledIcon,
  StyledButtonWrapper,
  StyledLocationIconRect,
  StyledLocationIcon,
  addressLinkStyles,
  StyledTooltip,
  subscribeButtonStyles,
}
